export class GISFileMessage {
  constructor(created, creator, message, attachmentUrl) {
    this.created = created;
    this.creator = creator;
    this.message = message;
    this.attachmentUrl = attachmentUrl;
  }
}